import React, { useMemo, useCallback } from "react";
import DatePicker from "react-datepicker";
import { format, parse } from "date-fns";
import { enUS, ru, uk } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Styles from "./styles.module.scss";
import { sendIdoFormFailure } from "../../../store/main/action";

import "react-datepicker/dist/react-datepicker.css";

const LOCALES = { en: enUS, ru, uk };
const getLocale = (lng) => LOCALES[(lng || "en").split("-")[0]] || enUS;

const safeParseISODateOnly = (iso) => {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
    const d = parse(iso, "yyyy-MM-dd", new Date());
    d.setHours(12, 0, 0, 0);
    return d;
};

const toISODateOnly = (dateObj) => (dateObj ? format(dateObj, "yyyy-MM-dd") : "");

const CustomFormDatePicker = ({
                                  title,
                                  placeholder = "DD/MM/YYYY",
                                  className = "",
                                  err,
                                  value = "",
                                  onChangeAction,
                                  formErr,
                                  name,
                                  minDate,
                                  maxDate,
                                  ...rest
                              }) => {
    const { i18n } = useTranslation();
    const dispatch = useDispatch();

    const selected = useMemo(() => safeParseISODateOnly(value), [value]);
    const locale = useMemo(() => getLocale(i18n.language), [i18n.language]);

    const clearFieldError = useCallback(() => {
        if (formErr?.[name]) {
            const nextErr = { ...formErr };
            delete nextErr[name];
            dispatch(sendIdoFormFailure(nextErr));
        }
    }, [dispatch, formErr, name]);

    const handleChange = (dateObj) => {
        clearFieldError();
        onChangeAction?.(toISODateOnly(dateObj));
    };

    return (
        <div className={`${Styles.inputWrap} ${err ? Styles.inputWrapWithErr : ""}`}>
            {title && <div className={Styles.inputTitle}>{title}</div>}

            <DatePicker
                {...rest}
                selected={selected}
                onChange={handleChange}
                onCalendarClose={clearFieldError}
                dateFormat="dd/MM/yyyy"
                placeholderText={placeholder}
                locale={locale}
                showPopperArrow={false}
                popperPlacement="bottom-start"
                minDate={minDate}
                maxDate={maxDate}
                className={`${Styles.input} ${className}`.trim()}
                isClearable
            />

            {err && <div className={Styles.inputErr}>{err}</div>}
        </div>
    );
};

export default CustomFormDatePicker;
